// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__3El6y","rootCenter":"LoadMoreObserver_rootCenter__1cVLf","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1XOQG"};